import Swiper, { Autoplay, FreeMode, Navigation } from "swiper";

Swiper.use([Autoplay, FreeMode, Navigation]);

if (document.querySelector(".opportunity-carousel")) {
  new Swiper(".opportunity-carousel", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 8000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      568: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 70,
      },
    },
  });
}

if (document.querySelector(".logos-carousel")) {
  new Swiper(".logos-carousel", {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,
    speed: 4000,
    noSwiping: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
      waitForTransition: true,
    },
    breakpoints: {
      568: {
        slidesPerView: 4,
        spaceBetween: 90,
      },
      768: {
        slidesPerView: 5,
        spaceBetween: 90,
      },
      1280: {
        speed: 8000,
        slidesPerView: 6,
        spaceBetween: 90,
      },
    },
  });
}

const galleryMainEl = document.querySelector(".gallery-carousel-slide");
const galleryThumbsEl = document.querySelector(".gallery-carousel-thumbnails");

if (galleryMainEl && galleryThumbsEl) {
  const gallerySlideCount = galleryMainEl.querySelectorAll(
    ".swiper-wrapper > .swiper-slide"
  ).length;

  const thumbsSwiper = new Swiper(galleryThumbsEl, {
    loop: gallerySlideCount > 2,
    spaceBetween: 8,
    slidesPerView: 2,
    watchSlidesProgress: false,
    allowTouchMove: gallerySlideCount > 2,
  });

  const galleryColumn = galleryMainEl.parentElement;
  const nextEl = galleryColumn?.querySelector(".gallery-carousel-next");
  const prevEl = galleryColumn?.querySelector(".gallery-carousel-prev");

  function syncThumbsToMain(main) {
    if (gallerySlideCount < 2 || !thumbsSwiper || thumbsSwiper.destroyed) return;
    const firstThumbIndex = (main.realIndex + 1) % gallerySlideCount;
    const speed =
      typeof main.params.speed === "number" ? main.params.speed : 300;
    if (thumbsSwiper.params.loop) {
      thumbsSwiper.slideToLoop(firstThumbIndex, speed);
    } else {
      thumbsSwiper.slideTo(firstThumbIndex, speed);
    }
  }

  const mainSwiper = new Swiper(galleryMainEl, {
    loop: gallerySlideCount > 1,
    spaceBetween: 10,
    ...(nextEl && prevEl
      ? {
          navigation: {
            nextEl,
            prevEl,
          },
        }
      : {}),
    on: {
      init(swiper) {
        syncThumbsToMain(swiper);
      },
      slideChange(swiper) {
        syncThumbsToMain(swiper);
      },
    },
  });

  galleryThumbsEl.addEventListener("click", (e) => {
    const slide = e.target.closest(".swiper-slide");
    if (!slide || !galleryThumbsEl.contains(slide)) return;
    const raw = slide.getAttribute("data-swiper-slide-index");
    if (raw == null) return;
    const idx = parseInt(raw, 10);
    if (Number.isNaN(idx)) return;
    if (mainSwiper.params.loop) {
      mainSwiper.slideToLoop(idx);
    } else {
      mainSwiper.slideTo(idx);
    }
  });
}
